/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { CreateFabricTableShortcutDemoResponseResultsInner } from '../models/CreateFabricTableShortcutDemoResponseResultsInner';

/**
* Response containing results for each Fabric table shortcut creation attempt
*/
export class CreateFabricTableShortcutDemoResponse {
  /**
  * Results for each table shortcut creation request
  */
  'results': Array<CreateFabricTableShortcutDemoResponseResultsInner>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "results",
      "baseName": "results",
      "type": "Array<CreateFabricTableShortcutDemoResponseResultsInner>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CreateFabricTableShortcutDemoResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

